import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { styled } from '@mui/material/styles';
import { ModalConfirm } from '@components/Modal';
import { useTranslation } from '@hooks';
import { accountActions, alertActions } from '@actions';
import { authService } from '@services';
import { handleApiError } from '@helpers/api';
import EditModal, { FORM_TYPE } from './EditModal';
import UserTable from './UserTable';

const Container = styled('div')({
    '@media (max-width: 1024px)': {
        overflowY: 'auto',
        overflowX: 'hidden',
        height: 'calc(var(--100vh) - 221px)',
    },
});

const UserManagement = () => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [modal, setModal] = useState({ open: false, type: FORM_TYPE.NEW });
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

    const user = useSelector(state => state.auth.user);
    const account = useSelector(state => state.account?.account);
    const brands = useSelector(state => state.brands?.data || []);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const onDeleteUser = async () => {
        setDeleteModalOpen(false);
        try {
            await authService.deleteUser(selectedUser.id);
            await dispatch(accountActions.get());
            dispatch(alertActions.success(t('alertMessages.deleteSuccess')));
        } catch (error) {
            handleApiError(error, 'alertMessages.deleteFail');
        }
        setSelectedUser(null);
    };

    return (
        <Container>
            <UserTable
                currentUser={user}
                account={account}
                setSelectedUser={setSelectedUser}
                setDeleteModalOpen={setDeleteModalOpen}
                setModal={setModal}
            />
            {modal.open && (
                <EditModal
                    selectedUser={selectedUser}
                    setSelectedUser={setSelectedUser}
                    modal={modal}
                    setModal={setModal}
                    brands={brands}
                    account={account}
                />
            )}
            {isDeleteModalOpen && (
                <ModalConfirm
                    isOpen={isDeleteModalOpen}
                    handleClose={() => setDeleteModalOpen(false)}
                    title={t('common.deleteTitle')}
                    description={t('common.deleteDescription')}
                    onPrimaryAction={onDeleteUser}
                    primaryActionText={t('buttons.delete')}
                    primaryActionType="danger"
                    onSecondaryAction={() => {
                        setDeleteModalOpen(false);
                        setSelectedUser(null);
                    }}
                />
            )}
        </Container>
    );
};

export default UserManagement;
